export default __webpack_public_path__ + "static/media/404.65a6c88e.png";